import { render } from "./OrderDelivery.vue?vue&type=template&id=3d902520&scoped=true"
import script from "./OrderDelivery.vue?vue&type=script&lang=js"
export * from "./OrderDelivery.vue?vue&type=script&lang=js"

import "./OrderDelivery.vue?vue&type=style&index=0&id=3d902520&lang=css"
import "./OrderDelivery.vue?vue&type=style&index=1&id=3d902520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d902520"]])

export default __exports__